import { render, staticRenderFns } from "./TeacherGeneralForm.vue?vue&type=template&id=55356bef"
import script from "./TeacherGeneralForm.vue?vue&type=script&lang=js"
export * from "./TeacherGeneralForm.vue?vue&type=script&lang=js"
import style0 from "./TeacherGeneralForm.vue?vue&type=style&index=0&id=55356bef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VForm,VRow,VTextField,VTextarea})
